import { T_TRIALS_EMAIL } from '@tempus/trials-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    paddingTop: '100px',
  },
  headline: {
    lineHeight: '48px',
    fontWeight: 500,
  },
});

const HelpDesk: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h1 className={classes.headline}>Whoops Seems You Do Not Have Access To This Page!</h1>
      <h4>Contact {T_TRIALS_EMAIL} to request access or additional support.</h4>
    </div>
  );
};

export default HelpDesk;
